<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Novo Usuário</b>
            </h3>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="empresa">Empresa</label>
                  <v-select v-model="empresaSelecionada" :options="empresas"></v-select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-5">
                <div :class="{'form-group': true, 'has-error':errors.has('name') }">
                  <label for="name">Nome Completo</label>
                  <input
                    class="form-control"
                    name="name"
                    type="text"
                    v-model="dados.name"
                    v-validate="'required'"
                  >
                  <span v-show="errors.has('name')" class="help-block">Campo obrigatório</span>
                </div>
              </div>

              <div class="col-sm-3">
                <div :class="{'form-group': true, 'has-error':errors.has('login') }">
                  <label for="login">Login</label>
                  <input
                    class="form-control"
                    name="login"
                    type="text"
                    v-model="dados.login"
                    v-validate="'required'"
                  >
                  <span v-show="errors.has('name')" class="help-block">Campo obrigatório</span>
                </div>
              </div>
              <div class="col-sm-4">
                <div :class="{'form-group': true, 'has-error':errors.has('email') }">
                  <label for="email">Email</label>
                  <input class="form-control" name="email" type="text" v-model="dados.email">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <div :class="{'form-group': true, 'has-error':errors.has('password') }">
                  <label for="password">Senha</label>
                  <input
                    class="form-control"
                    name="password"
                    type="password"
                    v-model="dados.password"
                    v-validate="'required'"
                    :disabled="atualizacao"
                  >
                  <span v-show="errors.has('password')" class="help-block">Campo obrigatório</span>
                </div>
              </div>
              <div class="col-sm-4">
                <div :class="{'form-group': true, 'has-error':errors.has('confirmacao') }">
                  <label for="confirmacao">Redigite a Senha</label>
                  <input
                    class="form-control"
                    name="confirmacao"
                    type="password"
                    v-model="controle.confirmacao_senha"
                    v-validate="'required'"
                    :disabled="atualizacao"
                  >
                  <span v-show="errors.has('confirmacao')" class="help-block">Campo obrigatório</span>
                </div>
              </div>
              <div class="col-sm-4">
                <div :class="{'form-group': true, 'has-error':errors.has('nivel') }">
                  <label for="nivel">Nível</label>
                  <select class="form-control" v-model="dados.nivel" name="nivel" v-validate="'required'">
                    <option value='1'>Usuário</option>
					          <option value='2'>Administrador</option>
                  </select>
                  <span v-show="errors.has('nivel')" class="help-block">Campo obrigatório</span>
                </div>
              </div>
            </div>
          </div>
          <div class="box-footer text-right">
            <router-link tag="button" to="/administracao/usuarios" class="btn btn-default">Cancelar</router-link>
            <button class="btn btn-primary" @click="salvar()">Salvar</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import { mask } from "vue-the-mask";
import vSelect from "vue-select";

export default {
  directives: { mask },
  data() {
    return {
      atualizacao: false,
      controle: {
        confirmacao_senha: ""
      },
      dados: {
        name: "",
        login: "",
        password: "",
        email: "",
        nivel: "1",
      },
      empresaSelecionada: null,
      empresas: []
    };
  },
  mounted() {
    this.getEmpresas();
    this.$nextTick(() => {
     if (this.$route.params.idUsuario) {
      this.getById(this.$route.params.idUsuario);
      this.atualizacao = true;
    }
    });
  },

  methods: {
    getEmpresas() {
       axios
        .get(
          `${this.$store.state.serverURI}/api/empresa/dataForSelect`,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          console.log(response.data);
          this.empresas = response.data;
        });
    },
    getById(id) {
      this.$store.commit("TOGGLE_LOADING");
      axios
        .get(
          `${this.$store.state.serverURI}/api/usuario/getById/` + id,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          this.dados = response.data;
          this.empresas.map((empresa) => {
            if (empresa.value == this.dados.empresa_id) {
              this.empresaSelecionada = empresa;
            }
          });
        });
    },
    salvar() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit("TOGGLE_LOADING");
          if (this.atualizacao) {
            axios
              .post(
                `${this.$store.state.serverURI}/api/usuario/update/` +
                  this.dados.id,
                this.dados,
                this.$store.getters.getHeaderAuth
              )
              .then(response => {
                this.$store.commit("SHOW_ALERT_SUCCESS");
                this.$swal({
                  type: response.data.status == 200 ? "success" : "error",
                  title:
                    response.data.status == 200
                      ? "Tudo Certo!"
                      : "Ops! Ocorreu um erro.",
                  text: response.data.msg,
                  showConfirmButton: false,
                  timer: 1500
                });
                this.$router.push("/administracao/usuarios");
              })
              .catch(error => {
                this.$store.commit("SHOW_ALERT_ERROR");
                console.log(error);
              });
          } else {
            axios
              .post(
                `${this.$store.state.serverURI}/api/usuario/create`,
                this.dados,
                this.$store.getters.getHeaderAuth
              )
              .then(response => {
                this.$store.commit("SHOW_ALERT_SUCCESS");
                this.$swal({
                  type: response.data.status == 200 ? "success" : "error",
                  title:
                    response.data.status == 200
                      ? "Tudo Certo!"
                      : "Ops! Ocorreu um erro.",
                  text: response.data.msg,
                  showConfirmButton: false,
                  timer: 1500
                });
                this.$router.push("/administracao/usuarios");
              })
              .catch(error => {
                this.$store.commit("SHOW_ALERT_ERROR");
                console.log(error);
              });
          }
        }
        this.$store.commit("TOGGLE_LOADING");
        return false;
      });
    }
  },
  watch: {
    empresaSelecionada: function(val) {
      this.dados.empresa_id = val.value;
    }
  },
  components: {
    vSelect
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// form.vue?d9411cb4